import { render } from "./CyclePoints.vue?vue&type=template&id=6ca1e3fa"
import script from "./CyclePoints.vue?vue&type=script&lang=js"
export * from "./CyclePoints.vue?vue&type=script&lang=js"
script.render = render

export default script